// ACTIONS
export const REGISTER = 'offerzen/zenModal/REGISTER'
export const TOGGLE = 'offerzen/zenModal/TOGGLE'

export const register = (name, isActive = false) => ({
  type: REGISTER,
  payload: { name, isActive },
})

export const toggleModal = (name, isActive) => ({
  type: TOGGLE,
  payload: { name, isActive },
})

// REDUCERS
const initialState = {
  isActive: false,
}

const modal = (state = initialState, { type, payload }) => {
  switch (type) {
    case REGISTER:
      return {
        ...state,
        ...payload,
      }

    case TOGGLE:
      return {
        ...state,
        ...payload,
      }

    default:
      return state
  }
}

const modalReducer = (state = {}, { type, payload }) => {
  switch (type) {
    case REGISTER:
      return {
        ...state,
        [payload.name]: modal(undefined, { type, payload }),
      }

    case TOGGLE:
      return {
        ...state,
        [payload.name]: modal(state[payload.name], { type, payload }),
      }

    default:
      return state
  }
}

export default modalReducer
